import React from 'react';
import { AnyObject, FormApi } from 'final-form';
import { Form } from 'react-final-form';
import Dialog from 'src/components/common/Dialog.redesign';
import FormSelect from 'src/components/controls/forms/redesign/FormFilterSelect';
import FormTextBox from 'src/components/controls/forms/redesign/FormTextbox';
import { useSelector } from 'react-redux';
import { IRootState } from 'src/reducers';
import { SelectItem } from 'src/models/common/SelectItem';
import { Url } from 'src/api';
import useFetch from 'use-http';
import useDebounce from 'src/util/hooks/use-debounce';
import Abstract from 'src/models/Abstract';
import Button from 'src/components/controls/forms/redesign/FormButton';

interface IEastTexasAbstractDialogProps {
    counties: SelectItem[];
    onCloseDialog?: () => void;
    onAbstractSelected?: (abstract: Abstract) => void;
}

const EastTexasAbstractDialog = (props: IEastTexasAbstractDialogProps) => {
    const appContext = useSelector((state: IRootState) => state.appContext);
    const { get, response } = useFetch();
    const [searchParams, setSearchParams] = React.useState(undefined);
    const [abstract, setAbstract] = React.useState<Abstract>(undefined);
    const [loading, setLoading] = React.useState<boolean>(false);
    const debouncedAbstractSearch = useDebounce(searchParams, 500);

    React.useEffect(() => {
        if (debouncedAbstractSearch) {
            const { formApi, countyId, abstractNumber } = debouncedAbstractSearch as AnyObject;
            setAbstract(undefined);
            if (countyId && abstractNumber) {
                searchAbstract(countyId, abstractNumber, formApi);
            }
        }
    }, [debouncedAbstractSearch]);

    const searchAbstract = async (countyId: number, abstractNumber: string, formApi: FormApi) => {
        setLoading(true);
        const result = await get(`${Url.project.getAbstract(appContext, countyId, abstractNumber)}`);

        if (response.ok) {
            if (result.id && result.id !== 0) {
                const responseAbstract = new Abstract();
                responseAbstract.id = result.id;
                responseAbstract.name = result.name;
                responseAbstract.abstractNumber = result.abstractNumber;
                responseAbstract.section = result.section;
                responseAbstract.legal = result.legal;
                responseAbstract.acres = result.acres;

                setAbstract(responseAbstract);
            }

            // if (parseInt(wtCounty.countyId, 10) === countyId && parseInt(wtCounty.abstractNumber, 10) === abstractNumber) {
            //     formApi.change(`westTexasCounties[${index}].abstractId`, result.id);
            //     formApi.change(`westTexasCounties[${index}].name`, result.name);
            //     formApi.change(`westTexasCounties[${index}].acres`, result.acres);
            //     formApi.change(`westTexasCounties[${index}].legal`, result.legal);
            //     formApi.change(`westTexasCounties[${index}].section`, result.section);
            // }
        }
        setLoading(false);
    };

    const onSubmit = async (values: AnyObject) => {
        props.onAbstractSelected(abstract);
        props.onCloseDialog();
    };

    const handleChange = (form: FormApi) => {
        const countyId = form.getFieldState('abstract.countyId')?.value;
        const abstractNumber: string = form.getFieldState('abstract.abstractNumber')?.value;

        setSearchParams({ countyId, abstractNumber: !abstractNumber ? undefined : abstractNumber });
    };

    const abstractPanel = (form: FormApi) => {
        if (loading) {
            return <div>loading...</div>;
        }

        if (!form.getFieldState('abstract.countyId')?.value) {
            return <div>Select County Above</div>;
        }

        if (!searchParams.abstractNumber) {
            return <div>Enter Search Term</div>;
        }

        if (!abstract || !abstract.id) {
            return <div>Abstract Not Found</div>;
        }

        return (
            <div>
                <div>
                    <span style={{ fontWeight: 'bold' }}>Name:</span> {abstract.name}
                    <span style={{ fontWeight: 'bold' }}>&nbsp;&nbsp;&nbsp;Acres:</span> {abstract.acres}
                </div>
                <div>
                    <span style={{ fontWeight: 'bold' }}>Legal:</span> {abstract.legal || '[No Legal]'}
                    <span style={{ fontWeight: 'bold' }}>&nbsp;&nbsp;&nbsp;Section:</span> {abstract.section || '[No Section]'}
                </div>
            </div>
        );
    };

    return (
        <Dialog title="Texas Abstract Search">
            <Form
                onSubmit={onSubmit}
                render={({ handleSubmit, form }) => {
                    return (
                        <form onSubmit={handleSubmit}>
                            <FormSelect name="abstract.countyId" items={props.counties} label="County" onChange={() => handleChange(form)} />
                            <FormTextBox name="abstract.abstractNumber" label="Abstract Number" onChange={() => handleChange(form)} />
                            <div style={{ border: '1px solid black', background: 'white', padding: '1rem', marginBottom: '1rem' }}>
                                {abstractPanel(form)}
                            </div>
                            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                <Button intent="link" onClick={props.onCloseDialog} text="Cancel" style={{ marginRight: '1rem' }} />
                                <Button disabled={abstract === undefined} intent="primary" onClick={onSubmit} text="Submit" />
                            </div>
                        </form>
                    );
                }}
            />
        </Dialog>
    );
};

export default EastTexasAbstractDialog;



// WEBPACK FOOTER //
// ./src/components/project/sections/TractComponents/panels/EastTexasAbstractDialog.tsx